import _ from "lodash";
import { LANDING_SECTION } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        landingItemEdit: _.cloneDeep(constants.LANDING_ITEM_INPUT)
    },
}

const landingItemEditReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LANDING_SECTION.SET_LANDING_ITEM_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case LANDING_SECTION.SET_LANDING_ITEM:
        case LANDING_SECTION.SET_LANDING_ITEM_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    landingItemEdit: action.landingItemEdit
                }
            })
        default:
            return state
    }
}

export default landingItemEditReducer